import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { parseIsoDate, toIsoDate } from './ecxDateUtils';
import '../layout/theme/EcxDatePicker.css';

function EcxInlineCalendar({
    value,
    onChange,
    disabled = false,
    className = '',
    min,
    max,
    tileClassName,
    multiSelect = false,
}) {
    const minDate = min ? parseIsoDate(min) : undefined;
    const maxDate = max ? parseIsoDate(max) : undefined;
    const selectedDates = multiSelect
        ? (Array.isArray(value) ? value.filter(Boolean) : [])
        : [];
    const selectedDate = !multiSelect && value ? parseIsoDate(value) : null;

    const handleChange = (nextValue) => {
        if (disabled || multiSelect || !(nextValue instanceof Date)) {
            return;
        }

        onChange?.(toIsoDate(nextValue));
    };

    const handleClickDay = (date) => {
        if (disabled || !multiSelect) {
            return;
        }

        const iso = toIsoDate(date);
        if (!iso) {
            return;
        }

        const next = selectedDates.includes(iso)
            ? selectedDates.filter((item) => item !== iso)
            : [...selectedDates, iso].sort();

        onChange?.(next);
    };

    const resolveTileClassName = (args) => {
        const custom =
            typeof tileClassName === 'function' ? tileClassName(args) : tileClassName;
        const multiSelected =
            multiSelect && selectedDates.includes(toIsoDate(args.date))
                ? 'ecx-calendar__tile--multi-selected'
                : '';

        return [custom, multiSelected].filter(Boolean).join(' ') || undefined;
    };

    return (
        <div
            className={`ecx-inline-calendar ecx-page${disabled ? ' ecx-inline-calendar--disabled' : ''}${
                multiSelect ? ' ecx-inline-calendar--multi' : ''
            }${className ? ` ${className}` : ''}`}
            aria-label={multiSelect ? 'Select multiple dates' : 'Schedule date calendar'}
        >
            <div className="ecx-inline-calendar__surface">
                <Calendar
                    className="ecx-calendar"
                    onChange={handleChange}
                    onClickDay={multiSelect ? handleClickDay : undefined}
                    value={multiSelect ? null : selectedDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    tileClassName={resolveTileClassName}
                    prev2Label={null}
                    next2Label={null}
                    prevLabel={<i className="bi bi-chevron-left" aria-hidden="true" />}
                    nextLabel={<i className="bi bi-chevron-right" aria-hidden="true" />}
                    showNeighboringMonth
                    showFixedNumberOfWeeks
                />
            </div>
        </div>
    );
}

export default EcxInlineCalendar;
